import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CContainer from "../components/container";

import HFaqsSVG from "../assets/images/h_faqs.svg";
import HContactSupportSVG from "../assets/images/h_contact_support.svg";
import HPrivacyPolicySVG from "../assets/images/h_privacy_policy.svg";

function SHelp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <CContainer>
      <div className="flex flex-col items-start justify-start md:h-[75%] md:w-[45%] sm:h-[80%] sm:w-[60%] h-[100%] w-[100%] bg-container-background sm:rounded-[10px] rounded-none">
        <div className="flex flex-col items-start justify-start h-[100%] w-[100%] p-[2%] overflow-scroll">
          <div className="h-[2%]" />
          <CHListTile
            icon={HFaqsSVG}
            title={t("help_2")}
            onClick={() => navigate("/faqs")}
          />
          <CHListTile
            icon={HContactSupportSVG}
            title={t("help_3")}
            onClick={() => {
              navigate("/contact_support");
            }}
          />
          <CHListTile
            icon={HPrivacyPolicySVG}
            title={t("help_4")}
            onClick={() => {
              navigate("/privacy_policy");
            }}
          />
        </div>
      </div>
    </CContainer>
  );
}

function CHListTile({ icon, title, onClick }) {
  return (
    <div
      className="flex flex-row items-center justify-start sm:my-[0.5%] my-[1%] p-[1%] w-[100%] cursor-pointer"
      onClick={onClick}
    >
      <img src={icon} className="h-[20px] w-[20px]" />
      <div className="w-[10px]" />
      <p className="text-[16px] font-[600]">{title}</p>
    </div>
  );
}

export default SHelp;
